import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Playfair Display', serif;
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.text};
    line-height: 1.6;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Cormorant Garamond', serif;
    margin-bottom: 1rem;
  }

  a {
    text-decoration: none;
    color: ${(props) => props.theme.colors.text};
    transition: color 0.3s ease;

    &:hover {
      color: ${(props) => props.theme.colors.accent};
    }
  }

  button {
    cursor: pointer;
    padding: 0.8rem 1.5rem;
    background-color: transparent;
    border: 1px solid ${(props) => props.theme.colors.accent};
    color: ${(props) => props.theme.colors.accent};
    font-family: 'Playfair Display', serif;
    transition: all 0.3s ease;

    &:hover {
      background-color: ${(props) => props.theme.colors.accent};
      color: ${(props) => props.theme.colors.primary};
    }
  }
`;

export default GlobalStyle;
